import { useState, useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { IconButton } from '@mui/material';
// import * as Icon from '@mui/icons-material/';
import { OrdemServicoAtualizar, OrdemServicoCadastrar, OrdemServicoCloning } from '../routes/RoutesNames';
import OrdemServicoController from '../controllers/OrdemServicoController';
import { formatDate } from '../shared/utils/helpers/date';
import { Column } from '../pages/Components/Table/Types';
import { ButtonMenu } from '../shared/components/ButtonMenu'
import { toast } from 'react-toastify';
import { openPDF } from '../pages/Components/OSPDF';
import PedidoController from '../controllers/PedidoController';
import Status from '../pages/Components/Status/Index';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  OS_id: number;
  cli_nome: string;
  os_dataEntrega: string;
  os_status: string;
}

const getStatusColor = (s: string) => ({
  'finalizado': '#4caf50',
  'aguardando aprovação': '#daa520',
  'em manutenção': '#33c9dc',
  'aberto': '#42a5f5',
  'faturamento': '#999',
  'reprovado': '#ef5350'
})[s.toLowerCase()] || '#999'

/* [28/09] Os status que a finalizacao em lote aceita, na forma normalizada.
   Os mesmos tres da PROC_OS_FINALIZAR_LOTE_VALIDAR - se um dia mudarem, tem de mudar
   nos dois lugares, e o servidor e quem manda: aqui e so para apagar a caixa. */
const PODEM_FINALIZAR_EM_LOTE = ['emmanutenção', 'aguardandoaprovação', 'faturamento'];

// replace(/\s/g) em vez de replaceAll, como no cadastro: o lib do projeto ainda nao
// tem replaceAll.
const normalizar = (s?: string) =>
  (s || '').toLowerCase().normalize('NFC').replace(/\s/g, '');

/**
 * A caixa de selecao de uma linha.
 *
 * Guarda o proprio estado visual em vez de receber "marcada" por prop. As linhas da
 * tabela sao montadas UMA VEZ, no handleSubmit, e o componente de tabela renderiza
 * `row[column.id]` direto - ele ignora o renderCell das colunas. JSX montado ali nao
 * acompanha mudanca de estado: um checkbox controlado de fora ficaria congelado.
 */
const CaixaSelecao = ({
  osId,
  elegivel,
  aoAlternar,
}: {
  osId: number;
  elegivel: boolean;
  aoAlternar: (osId: number, marcada: boolean) => void;
}) => {
  const [marcada, setMarcada] = useState(false);

  return (
    <Checkbox
      size='small'
      checked={marcada}
      disabled={!elegivel}
      onChange={(_, v) => {
        setMarcada(v);
        aoAlternar(osId, v);
      }}
      inputProps={{ 'aria-label': `Selecionar a ordem de serviço ${osId}` }}
    />
  );
};

const useOrderServicoPesquisar = () => {
  const { userId } = useSelector((state: any) => state.Authentication);
  const navigate = useNavigate();

  /* [28/09] SELECAO PARA A FINALIZACAO EM LOTE.
   *
   * O checkbox guarda o proprio estado visual, e nao le desta lista. Motivo: as linhas
   * da tabela sao montadas UMA VEZ, dentro do handleSubmit, e o componente de tabela
   * renderiza `row[column.id]` direto - ele ignora o renderCell das colunas. JSX montado
   * ali nao acompanha mudanca de estado, entao um checkbox controlado por esta lista
   * ficaria congelado no valor do momento em que a linha foi criada.
   *
   * Os dois se reencontram sempre que a busca roda de novo: as linhas sao remontadas com
   * checkbox zerado, e por isso a lista e limpa junto. */
  const [selecionadas, setSelecionadas] = useState<number[]>([]);
  const [finalizandoLote, setFinalizandoLote] = useState(false);
  const [ultimaBusca, setUltimaBusca] = useState<any>(null);

  const alternarSelecao = (osId: number, marcada: boolean) => {
    setSelecionadas((atual) =>
      marcada ? [...atual.filter((x) => x !== osId), osId] : atual.filter((x) => x !== osId));
  };

  const tableColumns: Column[] = [
    { id: 'Sel', label: '', width: 48, minWidth: 0, align: 'center' },
    { id: 'Id', label: 'Número Os', minWidth: 0 },
    { id: 'Status', label: 'Status', minWidth: 0, renderCell: (params: any) => params.value },
    { id: 'Cliente', label: 'Cliente', minWidth: 0 },
    { id: 'DataEntrega', label: 'Data de Entrega', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];

  const itemsStatus = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Aberto', label: 'Aberto' },
    { value: 'Em Manutenção', label: 'Em Manutenção' },
    { value: 'Aguardando Aprovação', label: 'Aguardando Aprovação' },
    { value: 'Faturamento', label: 'A Faturar' },
    { value: 'Reprovado', label: 'Reprovado' },
    { value: 'Finalizado', label: 'Finalizado' },
  ];

  const [tableRows, setTableRows] = useState<Row[]>([]);

  const initialValues = {
    os_id: null,
    os_status: '',
    os_clienteNome: '',
    os_dataEntrega: '',
    os_dataInc: '',
    os_dataAlt: '',
  };

  const handleSubmit = async (values: any) => {
    // Guardada para o recarregamento depois da finalizacao em lote: esta tela nao tem
    // ref do formulario, entao a busca se lembra dos proprios filtros.
    setUltimaBusca(values);

    const DataRows: any = [];
    const Response = await OrdemServicoController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          /* Selecionavel so nos tres status que a finalizacao em lote aceita. Nao e
             regra escondida: o status esta na coluna ao lado, entao o operador ve por
             que a caixa esta apagada.
             A flag "Gerar pedido ao finalizar" NAO entra aqui de proposito - ela nao
             aparece no grid, e apagar a caixa por um campo invisivel seria mudo. Quem
             recusa por causa dela e o servidor, dizendo o numero da O.S. */
          Sel: (
            <CaixaSelecao
              osId={item.OS_id}
              elegivel={PODEM_FINALIZAR_EM_LOTE.includes(normalizar(item.os_status))}
              aoAlternar={alternarSelecao}
            />
          ),
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleStatusItem(item.OS_id, 'EXECUTAR'), menu: "Executar" },
                { onClick: () => handleStatusItem(item.OS_id, 'REPROVADO'), menu: "Reprovado" },
                { onClick: () => handleStatusItem(item.OS_id, 'ORÇAMENTO'), menu: "Orçamento" },
                { onClick: () => handleStatusItem(item.OS_id, 'FATURAMENTO'), menu: "Faturamento" },
                { onClick: () => handleStatusItem(item.OS_id, 'FINALIZADO', item), menu: "Finalizar" },
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.OS_id), menu: "Excluir", confirmar: `Excluir a ordem de serviço nº ${item.OS_id}? Esta ação não pode ser desfeita.` },
                { onClick: () => handlePrint(item.OS_id), menu: "Imprimir" },
                { onClick: () => handleCloneOSItem(item.OS_id), menu: "Clonar OS" },
              ]}
            />
          ),
          Id: item.OS_id,
          Status: item?.os_status && (
            <Status text={item.os_status || ''} color={getStatusColor(item.os_status || '')} />

          ),
          Cliente: item.cli_nome,
          DataEntrega: formatDate(item.os_dataEntrega),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'success',
      });
    }
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(OrdemServicoCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(OrdemServicoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      // Quanto a OS aceita de edicao e decidido pelo status dela, ja na tela de
      // cadastro (ver STATUS_EDICAO_LIVRE em useOrderServicoCadastrar).
      navigate(OrdemServicoAtualizar.replace(':id', item.OS_id.toString() ?? ''));
    }
  };

  /**
   * [28/09] Finaliza as O.S. marcadas e consolida tudo em UM pedido.
   *
   * Uma chamada só: quem valida, cria a venda e finaliza é o servidor, numa operação.
   * Fazer isso aqui - finalizar uma a uma e depois pedir o pedido - deixaria O.S. em
   * FINALIZADO, que é status TERMINAL, sem pedido e sem caminho de volta pela tela, se
   * a geração falhasse no meio. Foi o beco da O.S. 62 em agosto.
   */
  const handleFinalizarLote = async () => {
    if (selecionadas.length === 0) {
      return toast('Selecione ao menos uma ordem de serviço.', { type: 'info' });
    }

    setFinalizandoLote(true);
    const Response = await PedidoController.FinalizarLoteOS(selecionadas);
    setFinalizandoLote(false);

    if (Response.StatusCode === 200) {
      const pedido = Response.Data?.[0]?.vnd_id ?? Response.Data?.vnd_id;
      const quantas = selecionadas.length;

      toast(
        `${quantas} ordem(ns) de serviço finalizada(s). Pedido ${pedido ?? ''} gerado.`,
        { type: 'success', autoClose: 10000 }
      );

      setSelecionadas([]);
      // Recarrega com os mesmos filtros: as linhas sao remontadas e os checkboxes
      // voltam a zero junto com a lista.
      await handleSubmit(ultimaBusca ?? initialValues);
    } else {
      // A recusa vem pronta do servidor, com o número da O.S. e o motivo.
      toast(Response.ErroDetalhado, { type: 'error', autoClose: 15000 });
    }
  };

  const handleStatusItem = async (os_id: number, os_status: string, item?: any) => {
    const request: any = { os_id: os_id, os_status: os_status };
    const response = await OrdemServicoController.AlterarStatus(request);

    // Se o status NAO mudou, para aqui: nao gera pedido nem avisa sucesso.
    // (Antes a geracao rodava mesmo com falha no status -> risco de pedido duplicado,
    // ex.: clicar "Finalizar" numa OS ja finalizada.)
    if (response.StatusCode !== 204) {
      toast(response.Data?.ErroDetalhado || 'Erro ao alterar o status do item!', {
        type: 'error',
      });
      return;
    }

    // Pedido de venda: SO no "Finalizar", SO se a OS pedir (flag OS_gerarPedido='S').
    // Gera 1 unica vez: FINALIZADO e terminal no PROC_OS_ATUALIZAR_STATUS (re-finalizar
    // da THROW e cai no if acima), entao a geracao nunca roda duas vezes para a mesma OS.
    // "Faturamento" continua so alterando o status.
    if (os_status?.toLowerCase() === 'finalizado' && item?.OS_gerarPedido?.toLowerCase() === 's') {
      const pedidoRes = await PedidoController.PedidoAdicionarOSFinalizada(os_id);
      if (pedidoRes?.StatusCode && pedidoRes.StatusCode >= 200 && pedidoRes.StatusCode < 300) {
        toast('Pedido de venda gerado a partir da OS!', { type: 'success' });
      } else {
        toast('OS finalizada, mas houve erro ao gerar o pedido de venda. Verifique.', {
          type: 'warning',
        });
      }
    }

    toast('Status do item alterado!', { type: 'success' });
    await handleSubmit(initialValues);
  }

  const handleDeleteItem = async (os_id: number) => {
    const request: any = { UsuId: userId, os_id: os_id };
    const response = await OrdemServicoController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Ordem serviço excluído com sucesso!', {
        type: 'success',
      });
      await handleSubmit(initialValues);
    } else if (response.StatusCode === 400) {
      const cut = s => s && s.substring(0, s.indexOf("!") + 1)
      toast(cut(response.Message?.split('\r')?.[0]) || 'Erro ao excluir a ordem de serviço', {
        type: 'error',
      });
    } else {
      toast('Erro ao excluir a ordem de serviço!', {
        type: 'error',
      });
    }
  };

  const handlePrint = async (osId: number) => {
    // Abre a guia ainda dentro do clique do usuário, senão o navegador bloqueia o pop-up
    const pdfWindow = window.open('', '_blank');
    const res = await OrdemServicoController.ListarUnico(osId);

    const formatDate = (dateStr: string | undefined) => {
      if (!dateStr) return "";
      const cleanDate = dateStr.split(' ')[0]; // Pega apenas a data 12/18/2025
      const [month, day, year] = cleanDate.split('/');
      return `${day}/${month}/${year}`; // Retorna 18/12/2025
    };

    const formatPhone = (phone: string | undefined, isCell: boolean) => {
      if (!phone) return "";
      const numbers = phone.replace(/\D/g, ""); // Remove tudo que não é número
      if (isCell) {
        // Máscara (99) 99999-9999
        return numbers.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
      }
      // Máscara (99) 9999-9999
      return numbers.replace(/^(\d{2})(\d{4})(\d{4}).*/, "($1) $2-$3");
    };

    if (res.StatusCode && res.StatusCode >= 200 && res.StatusCode < 300) {
      const data = {
        ...res.Data,
        DataEmissao: formatDate(res.Data?.DataEmissao?.split(' ')?.[0]),
        DataEntrega: formatDate(res.Data?.DataEntrega?.split(' ')?.[0]),
        HoraEntrega: res.Data?.DataEntrega?.split(' ')?.[1],
        clienteCelular: formatPhone(res.Data?.clienteCelular, true),
        clienteTelefone: formatPhone(res.Data?.clienteTelefone, false),
        items: [
          ...(res.Data?.pecasjson || []).map((i: any) => ({ ...(i?.peca), tipo: 'Produto' })),
          ...(res.Data?.servicosjson || []).map((i: any) => ({ ...(i?.servico), tipo: 'Serviço' }))
        ],
        itemsClient: res.Data.itensJson.map((i: any) => ({ ...(i?.item) })),
      }
      return openPDF(
        { ...data, total: (data.items || []).reduce((r: number, v: number) => r + (v?.valorTotal || 0), 0) },
        undefined,
        pdfWindow
      )
    }
    pdfWindow?.close();
    toast('Erro ao Obter Ordem de Serviço', { type: 'error' });
  }

  const handleCloneOSItem = (osId: number) => {
    navigate(OrdemServicoCloning.replace(':id', osId.toString() || ''));
  }

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return {
    handleNavigation,
    handleSubmit,
    handleEditItem,
    initialValues,
    tableColumns,
    tableRows,
    itemsStatus,
    selecionadas,
    finalizandoLote,
    handleFinalizarLote,
  };
};

export default useOrderServicoPesquisar;